module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="panel panel-success">\r\n    <div class="panel-heading">\r\n        <div class="inline center text-muted">\r\n            ';
 if (commenterId == 'admin') { 
__p+='\r\n                Commented by: <a>'+
((__t=( commenterName ))==null?'':__t)+
'</a>\r\n            ';
 } else  { 
__p+='\r\n                Commented by: <a href="/#person/'+
((__t=( commenterId ))==null?'':__t)+
'"  target="_blank" class="center">'+
((__t=( commenterName ))==null?'':__t)+
'</a>\r\n            ';
 } 
__p+=',\r\n            Comments: <span class="badge badge-success">'+
((__t=( commentsCount ))==null?'':__t)+
'</span>,\r\n            Related documents:\r\n            Signed - <span class="badge badge-success">'+
((__t=( signedLink ))==null?'':__t)+
'</span>,\r\n            Not Signed - <span class="badge badge-success">'+
((__t=( notSignedLink ))==null?'':__t)+
'</span>\r\n        </div>\r\n        <div class="pull-right inline">\r\n            <div data-toggle="collapse" data-target="#'+
((__t=( commenterIdInline ))==null?'':__t)+
'" class="collapser">\r\n                <span class="dotted-link">Show comments</span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class="collapse" id="'+
((__t=( commenterIdInline ))==null?'':__t)+
'">\r\n        <div class="panel-body">\r\n            <div>\r\n                <table class="table table-bordered table-condensed vertical-aligned-table">\r\n                <thead>\r\n                <tr>\r\n                    <th class="center" rowspan="2">Persons</th>\r\n                    <th class="center" rowspan="2">Orgs</th>\r\n                    <th class="center" colspan="5">Documents</th>\r\n                </tr>\r\n                <tr>\r\n                    <th class="center">Not assigned</th>\r\n                    <th class="center">Pending</th>\r\n                    <th class="center">Signed</th>\r\n                    <th class="center">Obsoleted</th>\r\n                    <th class="center">Total</th>\r\n                    <th class="center" rowspan="2">Comment</th>\r\n                    <th class="center" rowspan="2">Comment time</th>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                ';
 _.each(comments, function(comment, index) { 
__p+='\r\n                <tr>\r\n                    <td class="center">\r\n                        ';
 if ((comment.persons || []).length == 0) { 
__p+='\r\n                        0\r\n                        ';
 } else { 
__p+='\r\n                        <a href="'+
((__t=( getPersonsUrl(comment.persons || []) ))==null?'':__t)+
'"  target="_blank" class="center">\r\n                            '+
((__t=( (comment.persons || []).length ))==null?'':__t)+
'\r\n                        </a>\r\n                        ';
 } 
__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                        ';
 if ((comment.organizations || []).length == 0) { 
__p+='\r\n                        0\r\n                        ';
 } else { 
__p+='\r\n                        <a href="'+
((__t=( getOrganizationsUrl(comment.organizations || []) ))==null?'':__t)+
'"  target="_blank" class="center">\r\n                            '+
((__t=( (comment.organizations || []).length ))==null?'':__t)+
'\r\n                        </a>\r\n                        ';
 } 
__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                    ';
 if ((comment.notAssignedDocuments || []).length == 0) { 
__p+='\r\n                    <a class="center">'+
((__t=( (comment.notAssignedDocuments || []).length ))==null?'':__t)+
'</a>\r\n                    ';
 } else { 
__p+='\r\n                    <a href="'+
((__t=( getDocumentsUrl(comment.notAssignedDocuments || []) ))==null?'':__t)+
'"  target="_blank" class="center">'+
((__t=( (comment.notAssignedDocuments || []).length ))==null?'':__t)+
'</a>\r\n                    ';
 } 
__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                        ';
 if ((comment.pendingDocuments || []).length == 0) { 
__p+='\r\n                        <a class="center">'+
((__t=( (comment.pendingDocuments || []).length ))==null?'':__t)+
'</a>\r\n                        ';
 } else { 
__p+='\r\n                        <a href="'+
((__t=( getDocumentsUrl(comment.pendingDocuments || []) ))==null?'':__t)+
'"  target="_blank" class="center">'+
((__t=( (comment.pendingDocuments || []).length ))==null?'':__t)+
'</a>\r\n                        ';
 } 
__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                        ';
 if ((comment.signedDocuments || []).length == 0) { 
__p+='\r\n                        <a class="center">'+
((__t=( (comment.signedDocuments || []).length ))==null?'':__t)+
'</a>\r\n                        ';
 } else { 
__p+='\r\n                        <a href="'+
((__t=( getDocumentsUrl(comment.signedDocuments || []) ))==null?'':__t)+
'"  target="_blank" class="center">'+
((__t=( (comment.signedDocuments || []).length ))==null?'':__t)+
'</a>\r\n                        ';
 } 
__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                        ';
 if ((comment.obsoletedDocuments || []).length == 0) { 
__p+='\r\n                        <a class="center">'+
((__t=( (comment.obsoletedDocuments || []).length ))==null?'':__t)+
'</a>\r\n                        ';
 } else { 
__p+='\r\n                        <a href="'+
((__t=( getDocumentsUrl(comment.obsoletedDocuments || []) ))==null?'':__t)+
'"  target="_blank" class="center">'+
((__t=( (comment.obsoletedDocuments || []).length ))==null?'':__t)+
'</a>\r\n                        ';
 } 
__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                        ';
 if (getTotalCountForComment(comment) == 0) { 
__p+='\r\n                        <a class="center">'+
((__t=( getTotalCountForComment(comment) ))==null?'':__t)+
'</a>\r\n                        ';
 } else { 
__p+='\r\n                        <a href="'+
((__t=( getTotalDocumentsUrlForComment(comment) ))==null?'':__t)+
'"  target="_blank" class="center">'+
((__t=( getTotalCountForComment(comment) ))==null?'':__t)+
'</a>\r\n                        ';
 } 
__p+='\r\n                    </td>\r\n                    <td class="center"><a tabindex="0" class="btn btn-transparent comment-popover" role="button" data-toggle="popover" data-placement="left"\r\n                                          data-content="'+
((__t=( comment.commentText ))==null?'':__t)+
'" id="'+
((__t=( 'comment-popover-' + index ))==null?'':__t)+
'">View comment</a></td>\r\n                    <td class="center">'+
((__t=( formatDateTime(comment.time) ))==null?'':__t)+
'</td>\r\n                </tr>\r\n                ';
 }) 
__p+='\r\n                </tbody>\r\n            </table>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/statistics/document-sign-statistic-by-comments-row.html
// module id = 468
// module chunks = 0